import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-figma-journey-card',
  templateUrl: './figma-journey-card.component.html',
  styleUrls: ['./figma-journey-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FigmaJourneyCardComponent {
  @Input() title = '';
  @Input() excerpt = '';
  @Input() fullText = '';

  expanded = false;

  get bodyText(): string {
    return this.expanded ? this.fullText : this.excerpt;
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
